export default "__VITE_ASSET__LbcD6uaJ__"